
require.register("react-bootstrap/node_modules/core-js/library/fn/object/create.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "react-bootstrap/node_modules/core-js");
  (function() {
    var $ = require('../../modules/$');
module.exports = function create(P, D){
  return $.create(P, D);
};
  })();
});